module.exports = __webpack_public_path__ + "img/cute_natural_doodle_4.750fa01d.png";